//Back button icon
import * as backIcon from '../../assets/fontawesome/backspace-solid.svg'

//Ok button icon
import * as okIcon from '../../assets/fontawesome/check-square-solid.svg'

/**
 * @file Defines the {@link NumberInputManager} class
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

/** Class for handling NumberInput */
export class NumberInputManager {

    /**
     * Reference to number input node
     * @memberof NumberInputManager
     * @protected
     * @instance
     * @type {HTMLElement}
     */
    _elem

    /**
     * Load new assets into NumberInput
     */
    constructor() {

        this._elem = document.getElementById('numberInput') //Store reference to number input node
        let icons  = { 'Delete': backIcon, 'Ok': okIcon }   //Create object storing new icons

        //On mobile touchstart
        this._elem.addEventListener('touchstart', e_ => {

            //If user clicks off numpad
            if (e_.target.id === 'numberInput') {
                fadeElement(this._elem, 'out') //Fade numpad out
            }

        })

        //Loop through icons
        for (let i in icons) {
            document.getElementById(`numberInput${i}`).innerHTML = icons[i] //Replace icon
        }

    }

}